import { render, staticRenderFns } from "./PricingBreakdown.vue?vue&type=template&id=3520a2e9&scoped=true&"
import script from "./PricingBreakdown.vue?vue&type=script&lang=js&"
export * from "./PricingBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./PricingBreakdown.vue?vue&type=style&index=0&id=3520a2e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3520a2e9",
  null
  
)

export default component.exports